"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M8,15 L8.70769,17.1769 L11,17.1769 L9.13846,18.5308 L9.85385,20.7077 L8,19.3615 L6.13846,20.7077 L6.85385,18.5308 L5,17.1769 L7.29231,17.1769 L8,15 Z M14,3 L15.6247,7.25738 L20,7.25738 L16.5506,10.113 L17.7082,14.4353 L14,11.9386 L10.2918,14.4353 L11.4495,10.113 L8,7.25738 L12.3754,7.25738 L14,3 Z';